import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { isMobile } from "react-device-detect";
import { PRIMARY_COLOR } from "../../constants";
import gear from "../../media/gear_colored.svg";
const color = PRIMARY_COLOR; //"rgb(118, 7, 143)"

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		logoNameContainer: {
			whiteSpace: "nowrap",
			display: "flex",
			flexDirection: "row",

			marginTop: "0px",
			width: isMobile ? "100%" : "380px",
		},
		nameTop: {
			marginLeft: "10px",
			marginRight: "10px",
			fontSize: "40px",
			marginTop: "28px",
			color: color,
			fontFamily: "Roboto,Arial,Helvetica,sans-serif",
		},
		nameBottom: {
			color: "#a0b4d2",
			fontSize: "15px",
			width: "0px",
			whiteSpace: "nowrap",
			marginTop: "10px",
			marginLeft: "10px",
		},

		gear: {
			width: "45px",
			transition: "transform .7s ease-in-out",
			"&:hover": {
				transform: "rotate(360deg)",
			},
		},
		line: {
			borderLeft: "2px solid rgb(208, 208, 208)",
			height: "40px",
		},
	});
});

export const LogoNameMainPageScroll = () => {
	const classes = useStyles();
	return (
		<div className={classes.logoNameContainer}>
			<img src={gear} className={classes.gear}></img>
			<h1 className={classes.nameTop}>Dash AI</h1>
		</div>
	);
};

export const LogoNameMainPageScrollSmaller = () => {
	const classes = useStyles();
	return (
		<div className={classes.logoNameContainer}>
			<img
				src={gear}
				className={classes.gear}
				style={{ width: "40px" }}
			></img>
			<h1
				className={classes.nameTop}
				style={{ fontSize: "30px", marginTop: "20px" }}
			>
				Dash AI
			</h1>
		</div>
	);
};
